export default {
  SETUSER(state, { user }) {
    state.user = {};
    state.user = user;
  },
  SETALTFLAVORS(state, { altFlavors }) {
    state.altFlavors = {};
    state.altFlavors = altFlavors;
  },
  SETPAGETYPE(state, { pageType }) {
    state.pageType = {};
    state.pageType = pageType;
  },
  SETVERSION(state, { version }) {
    state.version = {};
    state.version = version;
  },
  SETSOURCETYPE(state, { sourceType }) {
    state.sourceType = {};
    state.sourceType = sourceType;
  },
  SETTOKEN(state, { token }) {
    state.token = {};
    state.token = token;
  },
  SETTOKENCOOKIE(state, { tokenCookie }) {
    state.tokenCookie = {};
    state.tokenCookie = tokenCookie;
  },
  SETCUSTOMERNUMBER(state, { customerNumber }) {
    state.customerNumber = {};
    state.customerNumber = customerNumber;
  },
  SETASTERISK(state, { asterisk }) {
    state.asterisk = {};
    state.asterisk = asterisk;
  },
  SETACCOUNTNO(state, { accountNo }) {
    state.accountNo = {};
    state.accountNo = accountNo;
  },
  SETPLATFORM(state, { platform }) {
    state.platform = {};
    state.platform = platform;
  },
  SETPLATFORMNAME(state, { platformName }) {
    state.platformName = {};
    state.platformName = platformName;
  },
  SETACCOUNTINFO(state, { accountInfo }) {
    state.accountInfo = {};
    state.accountInfo = accountInfo;
  },
  SETCURRENCY(state, { currency }) {
    state.currency = {};
    state.currency = currency;
  },
  SETRECHAREDATA(state, { rechargeData }) {
    state.rechargeData = {};
    state.rechargeData = rechargeData;
  },
  SETWITHDRAWALDATA(state, { withdrawalData }) {
    state.withdrawalData = {};
    state.withdrawalData = withdrawalData;
  },
  SETTRANSFERDATA(state, { transferData }) {
    state.transferData = {};
    state.transferData = transferData;
  },
  SETGTS2CUSTOMERID(state, { gts2CustomerId }) {
    state.gts2CustomerId = {};
    state.gts2CustomerId = gts2CustomerId;
  },
  SETGTS2ACCOUNTID(state, { gts2AccountId }) {
    state.gts2AccountId = {};
    state.gts2AccountId = gts2AccountId;
  },
  SETTABINDEX(state, { tabIndex }) {
    state.tabIndex = {};
    state.tabIndex = tabIndex;
  },
  SETTIMEDATA(state, { timeData }) {
    state.timeData = {};
    state.timeData = timeData;
  },
  SETPAYSWITCHSTATUS(state, { paySwitchStatus }) {
    state.paySwitchStatus = {};
    state.paySwitchStatus = paySwitchStatus;
  },
  SETTRADECONDITION(state, { tradeCondition }) {
    state.tradeCondition = {};
    state.tradeCondition = tradeCondition;
  },
  SETENTRUSTCONDITION(state, { entrustCondition }) {
    state.entrustCondition = {};
    state.entrustCondition = entrustCondition;
  },
  SETPROFITANDLOSSCONDITION(state, { profitAndLossCondition }) {
    state.profitAndLossCondition = {};
    state.profitAndLossCondition = profitAndLossCondition;
  },
  SETCREDITCONDITION(state, { creditCondition }) {
    state.creditCondition = {};
    state.creditCondition = creditCondition;
  },
  SETSTOPCONDITION(state, { stopCondition }) {
    state.stopCondition = {};
    state.stopCondition = stopCondition;
  },
  SETKEEPALIVE(state, { keepAlive }) {
    state.keepAlive = {};
    state.keepAlive = keepAlive;
  },
  SETTICKDATA(state, { tickData }) {
    state.tickData = {};
    state.tickData = tickData;
  },
};
